import type {
	Plan,
	PlanFlags,
	PlanLimits,
	SubscriptionResponse,
} from "../schemas";

export type PlanFeatureFlagKey = keyof PlanFlags;
export type PlanLimitKey = keyof PlanLimits;

export const getCurrentPlan = (
	subscriptionResponse?: SubscriptionResponse | null,
): Plan | null => subscriptionResponse?.suscripcion?.plan ?? null;

export const hasPlanFeature = (
	plan: Plan | null | undefined,
	flag: PlanFeatureFlagKey,
): boolean => Boolean(plan?.features.flags[flag]);

export const getPlanLimit = (
	plan: Plan | null | undefined,
	limitKey: PlanLimitKey,
): number | null => plan?.features.limits[limitKey] ?? null;

/**
 * A type predicate, not a plain boolean: callers guard on this and then do
 * arithmetic with `limit`, which only narrows if the signature says so.
 */
export const isUnlimitedLimit = (
	limit: number | null | undefined,
): limit is null | undefined => limit === null || limit === undefined;

export const isAtPlanLimit = (
	currentCount: number,
	limit: number | null | undefined,
): boolean => {
	if (isUnlimitedLimit(limit)) {
		return false;
	}

	return currentCount >= limit;
};

export const canCreateWithPlanLimit = (
	plan: Plan | null | undefined,
	limitKey: PlanLimitKey,
	currentCount: number,
): boolean => {
	if (!plan) {
		return false;
	}

	return !isAtPlanLimit(currentCount, getPlanLimit(plan, limitKey));
};
